//@ts-check

/**
 * @typedef {object} Marketplace
 * @property {string} id
 * @property {string} name
 * @property {boolean} isActive
 * @property {boolean} hasLogo
 * @property {string|null} logoUrl
 * @property {string} createdAt
 * @property {string} [updatedAt]
 */

/**
 * @typedef {import('./permissions.js').AuthUser} AuthUser
 */

/**
 * @typedef {object} UserFormValues
 * @property {string} name
 * @property {string} email
 * @property {string} [password]
 * @property {'admin'|'employee'} role
 * @property {{ record: boolean, view: boolean, download: boolean, share: boolean }} permissions
 */

/**
 * @typedef {object} Branding
 * @property {string} siteTitle
 * @property {string} siteSubtitle
 * @property {string|null} [logoUrl]
 * @property {string|null} [faviconUrl]
 * @property {boolean} [hasLogo]
 * @property {boolean} [hasFavicon]
 */

/**
 * @typedef {object} Video
 * @property {string} id
 * @property {string} trackingId
 * @property {string|null} marketplaceId
 * @property {string|null} recorderId
 * @property {string} recorderName
 * @property {string|null} driveAccountId
 * @property {number} sizeBytes
 * @property {number|null} durationSec
 * @property {string} mimeType
 * @property {'pending'|'uploading'|'completed'|'failed'} uploadStatus
 * @property {string|null} failureReason
 * @property {string|null} fileName
 * @property {string} createdAt
 * @property {string} [updatedAt]
 */

/**
 * @typedef {object} VideoListResponse
 * @property {Video[]} items
 * @property {number} page
 * @property {number} limit
 * @property {number} total
 * @property {number} totalPages
 */

/**
 * @typedef {object} ApiError
 * @property {string} [message]
 * @property {string} [code]
 */

/**
 * @param {unknown} err
 * @returns {string}
 */
export function getErrorMessage(err) {
  const axiosErr = /** @type {{ response?: { data?: { error?: ApiError } }, message?: string }} */ (
    err
  );
  return axiosErr.response?.data?.error?.message ?? axiosErr.message ?? 'Something went wrong';
}

export {};
